import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sectionIndex } from '../../features/dashboard/SectionOneSlice';
import { sectionStore } from '../../features/dashboard/SectionTwoSlice';
import Header from './Header';
import Input from '../form/Input';
import Select from '../form/Select';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';
import Access from '../../Access'

function ArchiveSectionTwo () {

    const dispatch = useDispatch();
    const [status, setStatus] = useState(false)
    const [section, setSection] = useState('')
    const [title, setTitle] = useState('')
    const [loading, setLoading] = useState(true)
    let {
        archiveSectionTwoLoading,
        archiveSectionTwoSuccess,
        message,
        errorSection,
        errorTitle,
    } = useSelector((state) => state.sectionTwo)
    const {sections} = useSelector(state => state.sectionTwo)

    useEffect(() => {
        // Handle Loading page Before Load DOM
        status === true ? setLoading(true) : setLoading(false);

        dispatch(sectionIndex(localStorage.getItem('token')));
        if(archiveSectionTwoSuccess === true && status === true) {
            toast.success(message,{
                position: "top-center",
                autoClose: 600,
              })
              setStatus(false)
              setLoading(false)
              setTitle('')
              setSection('')
            message = ''
        } else {
            setStatus(false)
            setLoading(false)
        }

        return () => {
            message = ''
        }

    },[archiveSectionTwoSuccess, message])

    const sectionTwoHandler = (event) => {
        event.preventDefault();
        setStatus(true)
        setLoading(true)
        const data = {
            'section_one_id': section,
            'title': title
        }
        dispatch(sectionStore(data));
    }
    return (
        <>
        { loading ? (<Loading />) : null }
        {
            message == 'access' ? <Access /> :
                <form className="text-end">
                    <div className='row g-2 p-5 my-5'>
                        <Header title={'ثبت بخش های انبار - بخش میانی'} />
                        <div className="col-6 ">
                            <Select
                                key='1'
                                tab='1'
                                col='col-12'
                                name='section_one_id'
                                title='انتخاب بخش اصلی'
                                value={section}
                                errorName={errorSection}
                                onchange={(e) => setSection(e.target.value)}
                                status='1'
                                data={sections}
                                focus='1'
                            />
                        </div>
                        <div className="col-6 ">
                            <Input 
                                key='2'
                                tab='2'
                                col='col-12'
                                type='text'
                                maxlength={255}
                                name='title'
                                value={title}
                                title='عنوان'
                                onchange={(e) => setTitle(e.target.value)}
                                placeholder='مانند : ساختمان کویر موتور' 
                                errorName={errorTitle}
                            />   
                        </div>
                        <div className="row g-2 px-0 mt-4 mb-0">
                            <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                                <Button 
                                    tab='3'
                                    title='ثبت بخش اصلی'
                                    design="position-relative px-4 py-1 btn btn-dark fw-bold"
                                    event={sectionTwoHandler}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            }
        </>
    )
}

export default ArchiveSectionTwo;